import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  TimeZoneChip as BaseTimeZoneChip,
  TimeZoneChipZone,
} from '@/components/ui/time-zone-chip';

export { TimeZoneChipZone };

interface TimeZoneChipProps {
  /** The chip's text, naming the zone the dates on screen count in. */
  children: ReactNode;
  /** The opening's IANA zone, named in the tooltip. eg 'America/Chicago' */
  timeZone: string;
  /** Replaces the tooltip's default body, which names the hours days run. */
  tooltipBody?: ReactNode;
}

/** The opening's time zone, with why it applies on hover or keyboard focus. */
export function TimeZoneChip({
  children,
  timeZone,
  tooltipBody,
}: TimeZoneChipProps) {
  return (
    <BaseTimeZoneChip
      tooltipTitle={
        <FormattedMessage
          defaultMessage="Why this time zone?"
          description="Title of the tooltip on the opening's time zone chip"
        />
      }
      tooltipBody={
        tooltipBody ?? (
          <p>
            <FormattedMessage
              defaultMessage="Hiring goals, campaign days and spend are counted from 12:00 AM to 11:59 PM in {timeZone}."
              description="Tooltip on the opening's time zone chip. {timeZone} is an IANA zone such as America/Chicago"
              values={{ timeZone }}
            />
          </p>
        )
      }
    >
      {children}
    </BaseTimeZoneChip>
  );
}
